<div (click)="close()" class="i-frame-container" *ngIf="display == 'start'">
  <iframe class="i-frame" src="https://www.youtube.com/playlist?list=PLN_X58kxNx_rhv65wlepePvDTJ_EtbXi2"></iframe>
  <!--https://www.nestas.eu/ga-start-nestas/-->
</div>
<div (click)="close()" class="i-frame-container" *ngIf="display == 'manual'">
  <iframe class="i-frame" src="/assets/producthandleiding_nestas_v3.pdf"></iframe>
  <!--https://www.nestas.eu/ga-start-nestas/-->
</div>
<div (click)="close()" class="i-frame-container" *ngIf="display == 'tuto_mobile'">
  <iframe class="i-frame" src="https://www.nestas.eu/je-woning-documenteren-met-je-smartphone-easy/"></iframe>
</div>